import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    type: null,
    email: null,
    isLoggedIn: false,
  },
  reducers: {
    setLoginDetails: (state, action) => {
      state.isLoggedIn = action?.payload?.isLoggedIn;
      state.type = action?.payload?.type;
      state.email = action?.payload?.email;
    },
    clearLoginDetails: (state) => {
      state.isLoggedIn = false;
      state.type = null;
      state.email = null;
    },
  },
});

export const { setLoginDetails, clearLoginDetails } = authSlice.actions;
export default authSlice.reducer;
